import { useState } from 'react'
import type { ReactNode } from 'react'
import {
  Button,
  IconShareDefault,
  IconBookmarkDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { ShareModal, type ShareContextData } from '@mc/share'
import Link from 'components/Link'
import { trackBookmarkClick } from '../events'

type SocialProps = {
  modalShareData: ShareContextData
  socialLinks: { name: string; linkPath: string; icon: ReactNode }[]
  useDeprecated?: boolean
  modalTitle?: string
}

const Social = ({
  modalTitle,
  modalShareData,
  socialLinks,
  useDeprecated = true,
}: SocialProps) => {
  const [showShareModal, setShowShareModal] = useState(false)
  const { t } = useTranslation('@mc/next')

  const toggleShareModalClose = () => {
    setShowShareModal(!showShareModal)
  }

  return (
    <div className='d-flex flex-lg-column align-items-center'>
      <span
        className='mc-text-h8 mc-text--uppercase mc-text--muted mc-mt-4 mc-mb-2 mc-mx-1'
        id='save'
      >
        {t('article.details.social.save')}
      </span>
      <Link
        ariaLabelledby='save'
        className='c-button c-button--symmetrical mc-corners--circle c-button--tertiary c-button--sm mc-m-1'
        href={paths.logIn()}
        isBasic
        onClick={trackBookmarkClick}
      >
        <IconBookmarkDefault className='mc-icon--3 mc-opacity--muted' />
      </Link>
      <span className='mc-text-h8 mc-text--uppercase mc-text--muted mc-mt-4 mc-mb-2 mc-mx-1'>
        {t('article.details.social.share')}
      </span>
      {socialLinks.map((social) => (
        <Button
          render={<a href={social.linkPath} target='_blank' rel='noreferrer' />}
          className='mc-m-1'
          key={social.name}
          kind='tertiary'
          rounded
          size='small'
        >
          <span className='mc-sr-only'>
            {t('lesson.details.a11y.network', { network: social.name })}
          </span>
          {social.icon}
        </Button>
      ))}
      <Button
        className='mc-m-1'
        kind='tertiary'
        onClick={toggleShareModalClose}
        rounded
        size='small'
      >
        <IconShareDefault
          srText={t('lesson.details.a11y.network', {
            network: 'your network',
          })}
        />
      </Button>
      <ShareModal
        show={showShareModal}
        shareData={modalShareData}
        onClose={toggleShareModalClose}
        useDeprecated={useDeprecated}
        modalTitle={modalTitle}
      />
    </div>
  )
}

export default Social
